import React from 'react';

import useUploader from './useUploader';

const Upload = () => {
  const { _dom } = useUploader();

  return (
    <>
      <div>
        <button ref={_dom}>업로드</button>
      </div>
      <div style={{ marginTop: 100 }}>
        <button onClick={() => alert('alert')}>알럿</button>
      </div>
    </>
  );
};

export default Upload;
